import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import { useNavigate } from 'react-router-dom';
import { productService } from '../../service/productservice';

// Image imports
import FrozenBitterLeaves1Lb from "../../public/category-img/vegetables/Frozenbitterleaves1Lb.jpeg";
import FrozenBitterLeaves5Lb from "../../public/category-img/vegetables/Frozenbitterleaves5Lb_prev_ui.png";
import DriedUzizaLeaves2oz from "../../public/category-img/vegetables/uziza_prev_ui.png";
import DriedUtaziLeaves2oz from "../../public/category-img/vegetables/utazi_prev_ui.png";
import DriedEwedu1oz from "../../public/category-img/vegetables/DriedEwedu_prev_ui.png";
import UzizaLeaves1_5oz from "../../public/category-img/vegetables/258c6c8b-46e3-45ba-bafd-c1f1d9612e50_prev_ui.png";
import UtaziLeaves1_5oz from "../../public/category-img/vegetables/89777079-43ad-434f-bd32-c96aeb5689f3_prev_ui.png";
import WashedDriedBitterLeaves5oz from "../../public/category-img/vegetables/nittaWasheddriedbitterleaves_prev_ui.png";
import BulbOfRedOnion from "../../public/category-img/vegetables/Bulbofredonion.jpg";
import BulbOfGarlic from "../../public/category-img/vegetables/Bulbofgarli.jpg";
import FreshGinger from "../../public/category-img/vegetables/gingerroot_600x.jpg";
import UkaziAfangLeaves2oz from "../../public/category-img/vegetables/ukazi_prev_ui.png";
import EhuruAfricanCalabash3oz from "../../public/category-img/vegetables/ehuru-2_1024x1024.png";
import FreshOkra12oz from "../../public/category-img/vegetables/FreshOkra12oz.jpeg";

export const vegetableproducts = [
  { id: "VEG001", name: "Frozen bitter leaves 1Lb", brand: "Grenier D'Afrique", supplier: "Onala African import", price: "$5.95", img: FrozenBitterLeaves1Lb, description: "Frozen Bitter Leaves are preserved fresh bitter leaves that maintain their nutritional value and distinctive bitter flavor. They are commonly used in African soups and stews, particularly in dishes like bitter leaf soup. Rich in vitamins and antioxidants, they offer both flavor and health benefits." },
  { id: "VEG002", name: "Frozen bitter leaves 5Lb", brand: "Grenier D'Afrique", supplier: "Onala African import", price: "$24.00", img: FrozenBitterLeaves5Lb, description: "Frozen Bitter Leaves are preserved fresh bitter leaves that maintain their nutritional value and distinctive bitter flavor. They are commonly used in African soups and stews, particularly in dishes like bitter leaf soup. Rich in vitamins and antioxidants, they offer both flavor and health benefits." },
  { id: "VEG003", name: "Dried Uziza leaves 2oz", brand: "Obiji foods", supplier: "Obiji foods", price: "$3.95", img: DriedUzizaLeaves2oz, description: "Dried Uziza leaves are aromatic leaves used in West African cuisine for their distinctive peppery flavor. They add depth to soups, stews, and sauces, commonly used in dishes like Uziza soup and pepper soup. Rich in essential oils and antioxidants, they provide both flavor and medicinal benefits." },
  { id: "VEG004", name: "Dried Utazi leaves 2oz", brand: "Obiji foods", supplier: "Obiji foods", price: "$4.95", img: DriedUtaziLeaves2oz, description: "Dried Utazi leaves are bitter-flavored leaves used in West African cuisine. They add a unique taste to soups and stews, and are often used in traditional medicine. Their distinct bitter flavor makes them a crucial ingredient in many traditional dishes." },
  { id: "VEG005", name: "Dried Ewedu 1oz", brand: "Nittemons food", supplier: "Nittemons food", price: "$3.25", img: DriedEwedu1oz, description: "Dried Ewedu is the dried form of the Ewedu plant, commonly used in West African cuisine, especially in Nigerian dishes. It is known for its mucilaginous texture, which makes it an excellent thickener in soups." },
  { id: "VEG006", name: "Uziza leaves 1.5oz", brand: "Nittemons food", supplier: "Nittemons food", price: "$4.95", img: UzizaLeaves1_5oz, description: "Uziza leaves are aromatic leaves used in West African cuisine for their distinctive peppery flavor. They add depth to soups, stews, and sauces, commonly used in dishes like Uziza soup and pepper soup. Rich in essential oils and antioxidants." },
  { id: "VEG007", name: "Utazi leaves 1.5oz", brand: "Nittemons food", supplier: "Nittemons food", price: "$4.95", img: UtaziLeaves1_5oz, description: "Utazi leaves are bitter-flavored leaves used in West African cuisine. They add a unique taste to soups and stews, and are often used in traditional medicine. Their distinct bitter flavor makes them a crucial ingredient in many traditional dishes." },
  { id: "VEG008", name: "Washed dried bitter leaves 5oz", brand: "Nittemons food", supplier: "Nittemons food", price: "$5.95", img: WashedDriedBitterLeaves5oz, description: "Washed dried bitter leaves are cleaned and preserved bitter leaves that maintain their distinctive flavor. They are commonly used in African soups and stews, particularly in dishes like bitter leaf soup. Rich in vitamins and antioxidants." },
  { id: "VEG009", name: "Bulb of red onion", brand: "Unbranded", supplier: "Walmart", price: "$1.41", img: BulbOfRedOnion, description: "Red onions are versatile vegetables with a sweet and slightly sharp flavor. They are essential in many African dishes, adding both flavor and color to stews, soups, and sauces. Rich in antioxidants and nutrients." },
  { id: "VEG010", name: "Bulb of garlic", brand: "Unbranded", supplier: "", price: "$2.00", img: BulbOfGarlic, description: "Garlic is a pungent, aromatic bulb that adds depth and flavor to African dishes. Used in many traditional recipes, it not only enhances taste but also offers numerous health benefits, including immune system support." },
  { id: "VEG011", name: "Fresh ginger", brand: "Unbranded", supplier: "", price: "$2.00", img: FreshGinger, description: "Fresh Ginger is a fragrant, spicy root that adds a zesty kick and warmth to a wide range of African dishes. Known for its distinct, aromatic flavor, it is commonly used in soups, stews, sauces, and teas." },
  { id: "VEG012", name: "Ukazi(Afang) leaves 2oz", brand: "Obiji foods", supplier: "", price: "$4.95", img: UkaziAfangLeaves2oz, description: "Ukazi (also known as Afang) is a highly nutritious, leafy green vegetable commonly used in West African cuisine, especially in soups and stews. Known for its slightly bitter taste and rich texture." },
  { id: "VEG013", name: "Ehuru African calabash 3oz", brand: "Nittemons food", supplier: "Nittemon food", price: "$7.95", img: EhuruAfricanCalabash3oz, description: "Ehuru, also known as African Calabash Nutmeg, is a spice commonly used in African cooking for its warm, aromatic flavor. It is often ground into a fine powder and added to soups, stews, sauces, and spice blends." },
  { id: "VEG014", name: "Fresh Okra 12oz", brand: "Unbranded", supplier: "", price: "$4.50", img: FreshOkra12oz, description: "Fresh Okra is a vibrant green vegetable known for its distinct texture and mild, slightly grassy flavor. Commonly used in African cuisine, it is perfect for making soups, stews, and dishes like Okra soup or Ogbono soup." }
];

const ProductCard = ({ product, updateCartCount, forceUpdateKey }) => {
  const [inCart, setInCart] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const foundItem = storedCartItems.find((item) => item.id === product.id);
    if (foundItem) {
      setInCart(true);
      setQuantity(foundItem.quantity);
    } else {
      setInCart(false);
      setQuantity(0);
    }
  }, [product.id, forceUpdateKey]);

  const handleAddToCart = () => {
    if (!inCart) {
      setInCart(true);
      setQuantity(1);
      saveToLocalStorage(product, 1);
      updateCartCount();
    }
  };

  const handleProductClick = () => {
    navigate(`/product/${product.name}`);
  };

  const saveToLocalStorage = (product, quantity) => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const updatedCart = [...cartItems, { ...product, quantity }];
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-3 w-full flex flex-col justify-between">
      <div onClick={handleProductClick} className="relative cursor-pointer flex justify-center items-center">
        <img
          src={product.img}
          alt={product.name}
          className={`h-60 w-full object-cover rounded-lg ${product.quantity === 0 ? 'opacity-50' : ''}`}
        />
        {product.quantity === 0 && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
            <span className="text-white text-lg font-semibold">Out of Stock</span>
          </div>
        )}
      </div>
      <div className="mt-4">
        <h3 className="text-lg font-semibold">{product.name}</h3>
        <p className="text-[#007D44]">{product.brand}</p>
        <p className="text-[#007D44] font-bold mt-2">${product.price}</p>
      </div>
      {inCart ? (
        <div className="mt-4 flex items-center justify-between border bg-slate-100 shadow-md rounded-full">
          <button
            onClick={() => {
              if (quantity > 1) {
                setQuantity((prevQuantity) => prevQuantity - 1);
                updateCartCount();
              }
            }}
            className="bg-[#38c13a] text-white py-2 px-4 rounded-lg hover:bg-[#2e9830]"
          >
            -
          </button>
          <span className="text-lg font-semibold">{quantity}</span>
          <button
            onClick={() => {
              setQuantity((prevQuantity) => prevQuantity + 1);
              updateCartCount();
            }}
            className="bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44]"
          >
            +
          </button>
        </div>
      ) : (
        <button
          onClick={handleAddToCart}
          className={`mt-4 bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44] ${
            product.quantity === 0 ? 'cursor-not-allowed opacity-50' : ''
          }`}
          disabled={product.quantity === 0}
        >
          Add to cart
        </button>
      )}
    </div>
  );
};


const Vegetables = () => {
  const [cartCount, setCartCount] = useState(0);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);


  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [cloudinaryUrls, setCloudinaryUrls] = useState({});
  const [products, setProducts] = useState([]);
  const [hasIncompatibleItems, setHasIncompatibleItems] = useState(false); // New state
    

 // Auto-upload products when component mounts
 useEffect(() => {
  const uploadProducts = async () => {
    try {
      setIsUploading(true);

      // Prepare products for upload
      const productsToUpload = vegetableproducts.map(product => ({
        ...product,
        id: product.id,
        name: product.name,
        brand: product.brand,
        description: product.description,
        category: 'vegetableproducts',
        quantity: 0,
        price: parseFloat(product.price.replace('$', ''))
      }));

      try {
        const result = await productService.bulkCreateProducts(productsToUpload);
        
        setUploadStatus({
          success: true,
          message: `${result.created} beauty products uploaded successfully`
        });
      } catch (error) {
        setUploadStatus({
          success: false,
          message: error.response?.data?.message || 'Product upload failed'
        });
      }
    } catch (error) {
      console.error('Error uploading products:', error);
      setUploadStatus({
        success: false,
        message: 'Failed to upload products'
      });
    } finally {
      setIsUploading(false);
    }
  };


  // Fetch products by category
  const fetchProducts = async () => {
    try {
      const result = await productService.getProductsByCategory('vegetableproducts');
      
      // If no products exist, trigger upload
      if (result.count === 0) {
        await uploadProducts();
      } else {
        setProducts(result.products);
        console.log(result.products)
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  fetchProducts();
}, []);

 


  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items on initial load
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);

  }, []);

  const updateCartCount = () => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items whenever cart updates
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);
  };

  const forceUpdateProducts = () => {
    setForceUpdateKey(prevKey => prevKey + 1); // This will force a re-render in ProductCard
  };

  return (
    <>
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} forceUpdateProducts={forceUpdateProducts} /> {/* Pass cart count to Navbar */}

      {/* Upload Status Notification */}
      {isUploading && (
        <div className="fixed top-0 left-0 w-full bg-yellow-500 text-white text-center py-2 z-50">
          Uploading sponge products...
        </div>
      )}
      
      {uploadStatus && (
        <div 
          className={`
            fixed 
            top-0 
            left-0 
            w-full 
            text-center 
            py-2 
            z-50 
            ${uploadStatus.success ? 'bg-green-500' : 'bg-red-500'} 
            text-white
          `}
        >
          {uploadStatus.message}
        </div>
      )}

      <div className="min-h-screen p-8 max-sm:p-1 lg:mt-[70px] mt-[130px]">
      {hasIncompatibleItems && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">
            Your cart contains items from a different box type. Please complete your current order 
            or clear the cart before selecting individual sponge products.
          </span>
          <button
            onClick={() => setHasIncompatibleItems(false)}
            className="absolute top-0 right-0 px-2 py-1"
          >
            ×
          </button>
        </div>
      )}
        <div className="flex justify-between items-center max-sm:flex-col max-sm:items-start mb-6">
          <h3 className="text-2xl font-semibold">Vegetables Products</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              updateCartCount={updateCartCount}
              forceUpdateKey={forceUpdateKey} // Pass updateCartCount to ProductCard
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Vegetables;